export type ScanSide = "left" | "right";

export function canonicalScanSide(
  viewerSide: ScanSide,
  swapped: boolean,
): ScanSide {
  return swapped ? (viewerSide === "left" ? "right" : "left") : viewerSide;
}

export function viewerScanPoints(
  pointsLeft: number,
  pointsRight: number,
  swapped: boolean,
): [number, number] {
  return swapped ? [pointsRight, pointsLeft] : [pointsLeft, pointsRight];
}
